module.exports = __webpack_public_path__ + "img/f7.cb2a6b29.jpg";